import getTranslation from "@components/RecipeGrid/util/getTranslation";
import { Icon, jnjCooking, jnjMeal, jnjPerson, jnjTime } from "@jmc/solid-design-system/src/components/atoms/Icon/Icon";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "../style.module.scss";
import { GeneralDataType, RecipeDetailsType } from "../types/RecipeProps";

export const RecipeDetails = (props: {
    recipeDetails: RecipeDetailsType;
    generalData: GeneralDataType;
}): JSX.Element => {
    const { t } = useTranslation();

    const { recipeDetails, generalData } = props;
    return (
        <div className={style.recipeDetails}>
            <div className={style.block}>
                <Icon icon={jnjPerson} type="jnj" size="medium" color="text-02" />
                <div className={style.data}>
                    <Typography size="s">{t("Serves", { ns: "recipe" })}</Typography>
                    <Typography size="l" color="dark">
                        {recipeDetails?.serves}
                    </Typography>
                </div>
            </div>
            <div className={style.block}>
                <Icon icon={jnjTime} type="jnj" size="medium" color="text-02" />
                <div className={style.data}>
                    <Typography size="s">{t("Total time", { ns: "recipe" })}</Typography>
                    <Typography size="l" color="dark">
                        {recipeDetails?.total_time === "1"
                            ? t("{{TOTAL_TIME}} Minute", {
                                  TOTAL_TIME: recipeDetails?.total_time,
                                  ns: "recipe",
                              })
                            : t("{{TOTAL_TIME}} Minutes", {
                                  TOTAL_TIME: recipeDetails?.total_time,
                                  ns: "recipe",
                              })}
                    </Typography>
                </div>
            </div>
            <div className={style.block}>
                <Icon icon={jnjMeal} type="jnj" size="medium" color="text-02" />
                <div className={style.data}>
                    <Typography size="s">{t("Course", { ns: "recipe" })}</Typography>
                    <Typography size="l" color="dark">
                        {generalData?.course.map((course, index) => {
                            const length = generalData?.course.length;
                            if (index === length - 1) {
                                return getTranslation(course, t);
                            }
                            return `${getTranslation(course, t)}, `;
                        })}
                    </Typography>
                </div>
            </div>
            <div className={style.block}>
                <Icon icon={jnjCooking} type="jnj" size="medium" color="text-02" />
                <div className={style.data}>
                    <Typography size="s">{t("Difficulty", { ns: "recipe" })}</Typography>
                    <Typography size="l" color="dark">
                        {getTranslation(generalData?.difficulty, t)}
                    </Typography>
                </div>
            </div>
        </div>
    );
};
